module.exports = __webpack_public_path__ + "img/manager.a92ae344.svg";